export default __webpack_public_path__ + "static/media/publishIcon.0e381e5b.svg";